import { Component, OnInit } from '@angular/core';

import { XmStore } from 'core/services';
import { StateService } from '@uirouter/core';

import { AddonsUtil } from 'my-account/activity/line-detail/addon/services/addons-util';
import { ProgressStatus } from 'my-account/constants';

@Component({
    selector: 'xm-addon-pending',
    templateUrl: './addon-pending.html',
    styleUrls: ['./addon-pending.scss'],
    standalone: false
})

export class XmAddonPending implements OnInit {
    private addonsUtil: AddonsUtil;

    constructor(xmStore: XmStore, state: StateService, addonsUtil: AddonsUtil) {
        Object.assign(this, { xmStore, state, addonsUtil });
    }

    public ngOnInit(): void {
        this.addonsUtil.completeAddonsPolling(ProgressStatus.PENDING);
    }
}
